import jquery from "jquery";
window.jQuery = window.$ = jquery;

// Bootstrap Framework
import "./scss/index.scss";
import "@popperjs/core";
import { Tooltip } from "bootstrap";
window.Tooltip = Tooltip;

var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]'),
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl);
});

import "slick-carousel";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import hcSticky from "hc-sticky";

//#region bootstrap navbar + hamburger + body scroll lock
var navbarMain = document.getElementById("navbarMain");
navbarMain.addEventListener("show.bs.collapse", function () {
  $(".navbar-toggler .hamburger").addClass("is-active");
  let scrollableNav = document.querySelector("#navbarMain");
  disableBodyScroll(scrollableNav);
});
navbarMain.addEventListener("hidden.bs.collapse", function () {
  $(".navbar-toggler .hamburger").removeClass("is-active");
  let scrollableNav = document.querySelector("#navbarMain");
  enableBodyScroll(scrollableNav);
});
$(function () {
  $(".nav-link--megamenu")
    .parent()
    .on("mouseenter", function (e) {
      let megamenu = $(this).find(".nav-link--megamenu").next(".megamenu");
      megamenu.addClass("megamenu--show");
    })
    .on("mouseleave", function (e) {
      let megamenu = $(this).find(".nav-link--megamenu").next(".megamenu");
      megamenu.removeClass("megamenu--show");
    });
});
//#endregion

//#region gallery

$(window).on("resize", function () {
  $(".gallery-thumbs").slick("setPosition");
});

$(function () {
  const $thumbs = $(".gallery-thumbs");
  const thumbCount = $thumbs.find("img").length;

  // sempre attivo slider principale
  $(".gallery-zooms").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
  });

  if (thumbCount > 4) {
    // 👉 ATTIVA SLICK SOLO SE SERVE
    $thumbs.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      infinite: true,
      arrows: true,
      focusOnSelect: true,
      asNavFor: ".gallery-zooms",
      swipeToSlide: true,
      prevArrow: '<button class="slick-prev"></button>',
      nextArrow: '<button class="slick-next"></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
            slidesToShow: 4,
            infinite: true,
            swipeToSlide: true,
          },
        },
      ],
    });

    // collega anche il main
    $(".gallery-zooms").slick(
      "slickSetOption",
      "asNavFor",
      ".gallery-thumbs",
      true,
    );
  } else {
    // 👉 NIENTE SLICK → layout statico
    $thumbs.addClass("no-slider");
  }
  $(".gallery-thumbs.no-slider img").first().addClass("active");
});
$(document).on("click", ".gallery-thumbs.no-slider img", function () {
  const index = $(this).index();

  // cambia slide principale
  $(".gallery-zooms").slick("slickGoTo", index);

  // gestione stato attivo (opzionale ma consigliato)
  $(".gallery-thumbs img").removeClass("active");
  $(this).addClass("active");
});
//#endregion
